import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {EditLineIcon} from '~library/svg/EditLineIcon';

import {link} from '~libSass/base/_exports.sass';
import './FakeInput.sass';

type FakeInput = {
  dataQaId: string;
  value: string;
  label: string;
  onEditClick: () => void;
};

export const FakeInput = ({value, label, onEditClick, dataQaId}: FakeInput) => (
  <div className="input-wrapper">
    <Typography variant="label2" size="small" classNames="input-label">
      {label}
    </Typography>
    <Button
      variant="transparent"
      onClick={onEditClick}
      data-qa-id={`${dataQaId}-edit`}
      className="rsvp__fake-input"
    >
      <div className="rsvp__fake-input__letter">
        <Typography variant="label2">{value.charAt(0).toUpperCase()}</Typography>
      </div>
      <div className="rsvp__fake-input__value">{value}</div>
      <EditLineIcon ratio={0.75} color={link} className="rsvp__fake-input__icon" />
    </Button>
  </div>
);
